import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: 'Wann werde ich etwas Echtes sehen?',
    a: 'Das erste Signal, das die meisten Frauen bemerken, ist weniger Haarausfall – in der Regel nach 3–4 Wochen. Sichtbare Dichteänderungen an Scheitel oder Haarwurzelzone brauchen bei konsequenter Anwendung typischerweise 6–10 Wochen. Das ist nicht sofort. Wir sagen das klar, weil wir lieber möchten, dass du mit dem richtigen Zeitrahmen rechnest, als aufzugeben, bevor du ihn erreichst.'
  }, {
    q: 'Was, wenn ich schon Öle ausprobiert habe und es nicht gewirkt hat?',
    a: 'Die meisten Öle, die du probiert hast, waren nicht für die kopfhaut-zentrierte Anwendung konzipiert. Sie waren für die Längen formuliert. Luisé ist speziell für die Anwendung an der Haarwurzelzone mit einer Präzisionspipette, leichter Absorption und einer Pre-Wash-Routinestruktur konzipiert. Das Auftragssystem ist anders – nicht nur das Etikett.'
  }, {
    q: 'Werden meine Ansätze fettig?',
    a: 'Nein – bei Anwendung nach Anweisung. Die Formel ist leicht und zieht ein statt zu beschichten. Wenn du sie am Abend vor dem Waschen oder als gezielte Pre-Wash-Behandlung verwendest, wird sie nicht beeinflussen, wie dein Haar tagsüber aussieht. Das ist eines der ersten Dinge, die Frauen kommentieren.'
  }, {
    q: 'Ist das für postpartalen Haarausfall, hormonelle Ausdünnung oder allgemeinen Ausfall?',
    a: 'Luisé ist für Frauen formuliert, die diffusen Haarausfall, reduzierte Dichte und sichtbare Kopfhautveränderungen erleben – unabhängig von der Ursache. Es ist keine medizinische Behandlung und diagnostiziert oder behandelt keine Grunderkrankungen – aber es wurde für das Kopfhaut-Milieu und die Routinekonsistenz konzipiert, die diese Gruppe von Frauen am meisten braucht.'
  }, {
    q: 'Warum ein Bundle? Kann ich nicht einfach eine Flasche ausprobieren?',
    a: 'Das kannst du. Aber basierend auf dem, was wir darüber wissen, wie lange sinnvoller Fortschritt dauert, empfehlen wir wirklich das 3-Flaschen-Ritual (ein 90-Tage-Konsistenzplan). Nicht, weil wir dir mehr verkaufen wollen – sondern weil die Frauen, die echte Ergebnisse sehen, die sind, die nicht in Woche fünf aufhören. Eine Flasche bringt dich zu den ersten Signalen. Drei Flaschen bringen dich zu dem Teil, der es wert ist zu sehen.'
  }];
  return <section className="py-16 bg-cream-dark/50" data-id="element-120">
      <div className="max-w-editorial mx-auto px-4" data-id="element-121">
        <h2 className="text-3xl font-heading font-semibold text-center text-charcoal mb-10" data-id="element-122">
          Noch unsicher? Die häufigsten Fragen – ehrlich beantwortet.
        </h2>

        <div className="space-y-4" data-id="element-123">
          {faqs.map((faq, i) => <FAQItem key={i} question={faq.q} answer={faq.a} data-id="element-124" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-charcoal/10 bg-white rounded-lg overflow-hidden" data-id="element-125">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" data-id="element-126">
        <span className="font-heading font-semibold text-lg text-charcoal pr-4" data-id="element-127">
          {question}
        </span>
        <span className="text-accent text-2xl font-light leading-none" data-id="element-128">
          {isOpen ? '−' : '+'}
        </span>
      </button>
      <AnimatePresence data-id="element-129">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-130">
            <div className="px-6 pb-5 text-charcoal/80 leading-relaxed" data-id="element-131">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}